export default __webpack_public_path__ + "static/spark_naver_2FA2-c119220752165769db654e802d70185d.png";